import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ palette, colors, spacing }: Theme) => createStyles({
  modal: {
    border: `2px solid ${colors.border}`,
  },
  closeButton: {
    position: 'absolute',
    right: spacing(1),
    top: spacing(1),
    color: palette.grey[500],
  },
  dialogContent: {
    padding: spacing(3),
  },
  cancelButton: palette.cancelAction,
  buttonIcon: {
    width: '18px',
    height: '18px',
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '0.21px',
    textTransform: 'none',
    paddingLeft: '0.25em',
    lineHeight: 'initial',
  },
  panelButton: {
    height: '36px',
    minWidth: '128px',
    '& > span:first-child': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },

    '& + button': {
      marginLeft: 10,
    },

    '&:disabled': {
      color: '#fff',
    },
  },
  dialogActions: {
    justifyContent: 'space-between',
  },
}), { name: 'DialogButton' });

export default useStyles;
